import { useConfigsContext } from '@/context/ConfigsContext';
import { DigitalAssetPod, getDigitalAssetPods, NFTVendor, Selection } from '@/services/cms';
import useSWR, { mutate } from 'swr';
export function useDigitalAssetPods(targetVenders: string[] = []) {
  const {
    store,
    appConfig
  } = useConfigsContext();
  const htcToken = store?.credentials?.htcToken;
  const profileId = store?.profile?.id;
  const USER_ASSETS_VENDORS_CHAINS = appConfig?.features?.user_assets_vendors_chains || [];
  const filteredVendorChains = targetVenders.length > 0 ? USER_ASSETS_VENDORS_CHAINS.filter(({
    vendor
  }) => targetVenders.includes(vendor)) : USER_ASSETS_VENDORS_CHAINS;
  const digitalAssetPods: DigitalAssetPod[] = filteredVendorChains?.map(({
    vendor: vendor_0,
    chains
  }) => {
    const podsOfVendorChains = chains.map(({
      name: chainName
    }) => {
      const {
        data
      } = useSWR(!htcToken || !profileId ? null : `${vendor_0}-${chainName}-pods`, () => getDigitalAssetPods(htcToken!, profileId!, vendor_0, chainName).then(res => res?.results));
      return data?.result || [];
    });
    return podsOfVendorChains.flat();
  }).flat();
  const digitalSelections: Selection[] = digitalAssetPods.map(pod => ({
    title: pod?.token_source?.name || '',
    scene_sid: pod?.token_source?.scene_sid,
    images: [{
      id: '',
      url: pod?.token_source?.image
    }],
    videos: [],
    nftData: {
      nftVendor: pod?.vendor_type as NFTVendor,
      externalData: {
        chain: pod?.chain,
        contract: pod?.contract,
        contract_type: pod?.contract_type,
        product_asset_id: pod?.external_data?.product_asset_id,
        product_id: pod?.external_data?.product_id,
        product_item_id: pod?.external_data?.product_item_id
      }
    }
  }));
  const fetchKeys = filteredVendorChains?.map(({
    vendor: vendor_1,
    chains: chains_0
  }) => chains_0.map(({
    name: chainName_0
  }) => `${vendor_1}-${chainName_0}-pods`)).flat();
  const refreshDigitalAssetPods = () => {
    fetchKeys.forEach(key => mutate(key)); // 重新整理所有的 SWR cache
  };
  if (!profileId) {
    return {
      digitalAssetPods: [],
      digitalSelections: []
    };
  }
  return {
    digitalAssetPods,
    digitalSelections,
    refreshDigitalAssetPods
  };
}